/* eslint-disable multiline-ternary */
import { Typography, Grid, Hidden, Skeleton } from '@mui/material'
import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Header } from './'

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints }) => ({
    root: {
      maxWidth: '960px'
    },
    image: {
      width: '100%',
      height: 'max-content'
    },
    skeleton: {
      height: '8em'
    }
  })
)
const Description = ({ className = '', category }) => {
  const classes = useStyles()
  return (
    <Grid
      container
      justifyContent='space-between'
      direction='row'
      classes={{ root: classes.root }}
      className={className}
      spacing={4}
      alignItems='flex-start'
      data-test='description'
    >
      <Grid item xs={12} sm={8}>
        <Header category={category ?? null} />
        <Typography data-test='description-content'>
          {category ? (
            category.category.description
          ) : (
            <>
              <Skeleton />
              <Skeleton />
            </>
          )}
        </Typography>
      </Grid>
      <Hidden smDown>
        <Grid container item sm={4} wrap data-test='description-image'>
          {category ? (
            <img
              src={category.category.heroImage}
              alt='Category image'
              className={classes.image}
            />
          ) : (
            <Skeleton
              variant='rectangular'
              className={`${classes.image} ${classes.skeleton} `}
            />
          )}
        </Grid>
      </Hidden>
    </Grid>
  )
}
export default Description
